import * as React from "react";

export const useWindow = () => {
  const openNewTab = React.useCallback((route: string) => {
    let url = window.location.origin;
    if (window.location.hash) {
      url += "/#";
    }
    if (!route.startsWith("/")) {
      url += "/";
    }
    url += route;

    window.open(url);
  }, []);

  return {
    openNewTab,
  };
};
